
{
  "headers": {
    "name": "Name",
    "createdAt": "Created On"
  },
  "loading": "Getting brands...",
  "no-data": "No brands",
  "no-query-results": "No brands match that search"
}
